import React from 'react';
import { getInitials } from '../utils/initials';

const Avatar = ({ user, size = 'md', className = '', testId }) => {
  const sizeClasses = {
    xs: 'h-6 w-6 text-[8px]',
    sm: 'h-7 w-7 text-[10px]',
    md: 'h-8 w-8 text-xs',
    lg: 'h-10 w-10 text-sm',
    xl: 'h-12 w-12 text-base',
    '2xl': 'h-16 w-16 text-lg',
    '3xl': 'h-24 w-24 text-2xl'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;

  if (!user) {
    return null;
  }

  if (user.avatar?.thumbUrl) {
    return (
      <img
        src={user.avatar.thumbUrl}
        alt={user.name || user.email}
        className={`${sizeClass} rounded-full ring-1 ring-brand-gold/40 bg-brand-surface object-cover ${className}`}
        data-testid={testId || 'header-avatar'}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full ring-1 ring-brand-gold/40 bg-brand-surface flex items-center justify-center text-brand-gold font-medium ${className}`}
      data-testid={testId || 'header-avatar-initials'}
    >
      {getInitials(user.name || user.email)}
    </div>
  );
};

export default Avatar;
